export const EMPTY_FLAT_FILTER = {
  rooms: {},
  type_realty: [],
  districts: [],
  price: {
    start: '',
    end: '',
  },
  floor: {},
  plannings: [],
  states: [],
  material: {},
  area: {
    start: '',
    end: '',
  },
}
export const SORTING_LIST = [
  { id: 'new', title: 'найновіші' },
  { id: 'cheap', title: 'найдешевші' },
  { id: 'expensive', title: 'найдорожчі' },
  { id: 'recommend', title: 'рекомендовані' },
]
